import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/casestudy/importer/casestudyImporterActions';

export default importerReducers(actions);
